import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Ptag } from "components/core";
import {
  HeaderRow,
  MaterialTable,
  MaterialTableContainer,
} from "components/core/BaseTable/styles";
import React, { useMemo } from "react";
import { formatDateReverse, formatToRupees } from "utlis/utils";

const HEADERS = [
  "Claim No.",
  "Employee No.",
  "Employee Name",
  "Patient Name",
  "Date of Admission",
  "Buffer Amount Utilized",
];
function CbTable({ tableData }) {
  const tableRows = useMemo(() => {
    return (
      <>
        <TableContainer sx={MaterialTableContainer}>
          <Table aria-label="simple table" sx={MaterialTable}>
            <TableHead>
              <TableRow>
                {HEADERS.map((header, index) => (
                  <TableCell
                    key={index}
                    variant="head"
                    align="center"
                    sx={HeaderRow}
                  >
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData &&
                tableData.map((batch, index) => {
                  return (
                    <TableRow
                      key={batch.id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell align="center" component="th" scope="row">
                        <Ptag style={{ display: "inline" }}>
                          {batch?.claim_number}
                        </Ptag>
                      </TableCell>
                      <TableCell align="center" component="th" scope="row">
                        <Ptag style={{ display: "inline" }}>
                          {batch?.employee_number}
                        </Ptag>
                      </TableCell>
                      <TableCell align="center" component="th" scope="row">
                        <Ptag style={{ display: "inline" }}>
                          {batch?.employee_name}
                        </Ptag>
                      </TableCell>
                      <TableCell align="center" component="th" scope="row">
                        <Ptag style={{ display: "inline" }}>
                          {batch?.patient_name}
                        </Ptag>
                      </TableCell>
                      <TableCell align="center" component="th" scope="row">
                        <Ptag style={{ display: "inline" }}>
                          {batch?.date_of_admission &&
                            formatDateReverse(batch?.date_of_admission)}
                        </Ptag>
                      </TableCell>
                      <TableCell align="center" component="th" scope="row">
                        <Ptag style={{ display: "inline" }}>
                          {batch?.buffer_amount_utilised &&
                            formatToRupees(batch?.buffer_amount_utilised)}
                        </Ptag>
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    );
  }, [tableData]);
  return (
    <>
      <Ptag
        fontSize="20px"
        fontWeight="700"
        marginBottom="2rem"
        marginTop="4rem"
      >
        History
      </Ptag>
      {tableRows}
    </>
  );
}

export default CbTable;
